import { createFileRoute } from "@tanstack/react-router";
import { SuperAdminPage } from "@/components/super-admin/super-admin-page";

export const Route = createFileRoute("/_dashboard/superadmin")({
  component: SuperAdminPage,
});
